import classes from './GettingStarted.module.scss';
import Image from 'next/image';
import Button from '../../atoms/button/Button';

export default function GettingStarted(props) {
    /**
     * return null needed for react render func
     */
    if (!props) return null;

    const siteContent = props[0];
    const stepSummary = props[1];

    const { image, icon_steps, getting_started } = stepSummary;

    return (
        <div className={classes.oGettingStarted}>
            <div className={`${classes.oContainer} container`}>
                <div className={`${classes.oRow} row`}>
                    <h2 className={`aSectionTitle _accent col fntH2`}>{siteContent.site_header}</h2>
                </div>
                <div className={`${classes.oRow} row`}>
                    <div className={`${classes.mBlockImage} col-12 col-md-6`}>
                        <figure className={classes.mImage}>
                            <Image
                                src={image?.data?.attributes?.url}
                                alt={`hero`}
                                width={image?.data?.attributes?.width}
                                height={image?.data?.attributes?.height}
                                className={classes.aImage}
                                aria-hidden="true"
                                layout="responsive"
                            />
                        </figure>
                    </div>
                    <div className={`${classes.mBlockContent} col-12 col-md-6`}>
                        <ul className={classes.mIconList}>
                            {icon_steps?.map((icon) => (
                                <li className={classes.mListItem} key={icon.id}>
                                    <span className={classes.mLinkIcon}>
                                        <Image
                                            src={`/web${icon.icon_path}`}
                                            alt={``}
                                            width={`48`}
                                            height={`48`}
                                            layout="responsive"
                                        />
                                    </span>
                                    <span className={`${classes.aText} fnt24f`}>{icon.step}</span>
                                </li>
                            ))}
                        </ul>
                        <div className={classes.ctaWrapper}>
                            <Button
                                url={getting_started.href}
                                label={getting_started.label}
                                style="btnPrimary"
                                isExternal="_parent"
                                iconPath=""
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.oBackgroundBlock}>
                <svg
                    width="360"
                    height="109"
                    viewBox="0 0 360 109"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMid meet"
                    className={`${classes.SvgSM} ${classes.aBgSvg}`}
                >
                    <path
                        d="M-29 21.1834C71.5167 -50.2135 175.259 81.087 237.064 89.2044C297.509 101.55 396.158 46.2739 460 69.1504V109H-29V21.1834Z"
                        fill="#FDB933"
                    />
                </svg>

                <svg
                    width="1024"
                    height="257"
                    viewBox="0 0 1024 257"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMid meet"
                    className={`${classes.SvgMD} ${classes.aBgSvg}`}
                >
                    <path
                        d="M1024.5 157.956C871.08 178.83 697.529 228.642 580.285 209.541C439.956 194.839 226.206 8.11393 0 0.255371V256.041H1024.5V157.956Z"
                        fill="#FDB933"
                    />
                </svg>
                <svg
                    width="1440"
                    height="257"
                    viewBox="0 0 1440 257"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMid meet"
                    className={`${classes.SvgLG} ${classes.aBgSvg}`}
                >
                    <path
                        d="M0 49.7599C296 -117.951 601.5 190.473 783.5 209.541C961.5 238.541 1252 108.697 1440 162.434V256.041H0V49.7599Z"
                        fill="#FDB933"
                    />
                </svg>
            </div>
        </div>
    );
}
